import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { RadioInput } from '@calendly/ui/components/radio-input';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { useSelector } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { isRestrictedFeatureSelector } from 'features/billing';
import { EXTERNAL, INTERNAL } from 'features/event_type_editor';
import { TypeOptionLabel, typeOptionsCss } from './styles';
const optionDescriptionCss = "onr56ep";
const ConfirmationTypeOption = ({
  checked,
  description,
  inputId,
  name,
  onSelect,
  title,
  trailing,
  value
}) => <TypeOptionLabel htmlFor={inputId}>
    <RadioInput checked={checked} id={inputId} label={<>
          <LabelText color="standard" size="large">{title}</LabelText>
          <BodyText className={optionDescriptionCss} color="muted" size="medium">
            {description}
          </BodyText>
          {trailing}
        </>} layout="horizontal" name={name} showControl value={value} variant="selectable" onChange={onSelect} />
  </TypeOptionLabel>;
export const ConfirmationPageTypeField = () => {
  const isUpgradeRequired = useSelector(state => isRestrictedFeatureSelector(state, {
    featureKey: 'invitee_redirect'
  }));
  const enforceUpgrade = useEnforceUpgrade('invitee_redirect');
  const [{
    value
  }, _, {
    setValue
  }] = useFormField({
    name: 'confirmationPageType'
  });
  const handleSelect = nextValue => {
    if (nextValue === INTERNAL) {
      setValue(INTERNAL);
      return;
    }
    enforceUpgrade(() => {
      setValue(EXTERNAL);
    });
  };
  return <div className={typeOptionsCss} data-testid="confirmation-page-type-field" role="radiogroup" aria-label={I18n.t('publisher.event_type_editor_crud.confirmation.after_booking_label')}>
      <ConfirmationTypeOption checked={value === INTERNAL} description={I18n.t('publisher.event_type_editor_crud.confirmation.internal_description')} inputId="confirmation-page-type-internal" name="confirmationPageType" title={I18n.t('publisher.event_type_editor_crud.confirmation.internal_title')} value={INTERNAL} onSelect={() => handleSelect(INTERNAL)} />
      <ConfirmationTypeOption checked={value === EXTERNAL} description={I18n.t('publisher.event_type_editor_crud.confirmation.external_description')} inputId="confirmation-page-type-external" name="confirmationPageType" title={I18n.t('publisher.event_types.confirmation_page.type.external')} trailing={isUpgradeRequired && <Badge>
            {I18n.t('publisher.event_type_editor.sections.booking_page_options.pro')}
          </Badge>} value={EXTERNAL} onSelect={() => handleSelect(EXTERNAL)} />
    </div>;
};

require("./confirmation_page_type_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./confirmation_page_type_field.js");